// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"A1-z","dimensionLabel":"B1-z","styleChooserControlWrapper":"C1-z","styleChooserControl":"D1-z","disabled":"E1-z","giftCard":"F1-z","styleChooserText":"G1-z"};